import { useRef } from "react";
import { useSnapshot } from "valtio";
import handelswegeTimebarState from "./states/handelswegeTimebarState";
import { stateEnglisch, stateNavigation, stateDevice } from "../../store";

const ERAS_DE = [
  "13. Jh. v. Chr.",
  "13. Jh. v. Chr.",
  "8.−6. Jh. v. Chr.",
  "1800",
  "1832",
  "1877",
  "2000",
];

const ERAS_EN = [
  "13th c. BC",
  "13th c. BC",
  "8th−6th c. BC",
  "1800",
  "1832",
  "1877",
  "2000",
];

const PAD = 40;

function Timebar({ eras }) {
  const n = eras.length;
  const snap = useSnapshot(handelswegeTimebarState);
  const snapNav = useSnapshot(stateNavigation);
  const snapDevice = useSnapshot(stateDevice);
  const trackRef = useRef(null);
  const dragging = useRef(false);

  const isPortrait = snapDevice.isPortrait;
  const containerWidth = isPortrait
    ? "100%"
    : `calc(100% - ${snapNav.sidebarWidth}px)`;

  const pos = (snap.splinePoint - 1) / (n - 1);
  const seg = snap.splinePoint - 1;

  const clamp01 = (v) => Math.max(0, Math.min(1, v));

  const applyFromClientX = (clientX) => {
    const rect = trackRef.current.getBoundingClientRect();
    const usable = rect.width - PAD * 2;
    const p = clamp01(usable > 0 ? (clientX - rect.left - PAD) / usable : 0);
    const idx = Math.round(p * (n - 1));
    handelswegeTimebarState.splinePoint = Math.max(1, Math.min(n, idx + 1));
  };

  const onPointerDown = (e) => {
    dragging.current = true;
    trackRef.current?.setPointerCapture(e.pointerId);
    applyFromClientX(e.clientX);
  };
  const onPointerMove = (e) => { if (dragging.current) applyFromClientX(e.clientX); };
  const onPointerUp = () => { dragging.current = false; };

  const handleLeftPct = `calc(${PAD}px + ${pos.toFixed(4)} * (100% - ${PAD * 2}px))`;

  return (
    <div style={{
      position: "fixed", left: 0, width: containerWidth,
      bottom: isPortrait ? "calc(31vh + 85px)" : "150px",
      display: "flex", justifyContent: "center",
      zIndex: 5, pointerEvents: "none",
    }}>
      <div style={{
        width: isPortrait ? "min(94vw, 480px)" : "min(60vw, 580px)",
        background: "rgba(0,0,0,0.52)", borderRadius: 10,
        padding: isPortrait ? "10px 8px 4px" : "10px 20px 14px",
        fontFamily: "'Helvetica Neue', Arial, sans-serif",
        userSelect: "none", WebkitUserSelect: "none", pointerEvents: "auto",
      }}>
        <div ref={trackRef} style={{ position: "relative", height: isPortrait ? 28 : 46,
          touchAction: "none", cursor: "ew-resize" }}
          onPointerDown={onPointerDown} onPointerMove={onPointerMove}
          onPointerUp={onPointerUp} onPointerCancel={onPointerUp}>
          <div style={{ position: "absolute", top: "50%", left: PAD, right: PAD,
            transform: "translateY(-50%)", height: 1.5,
            background: "rgba(255,255,255,0.4)", pointerEvents: "none" }} />
          <div style={{ position: "absolute", left: PAD, top: "50%",
            transform: "translate(-50%, -50%)", width: 28, height: 28,
            borderRadius: "50%", border: "2px solid rgba(255,255,255,0.5)",
            pointerEvents: "none" }} />
          <div style={{ position: "absolute", left: `calc(100% - ${PAD}px)`, top: "50%",
            transform: "translate(-50%, -50%)", width: 28, height: 28,
            borderRadius: "50%", border: "2px solid rgba(255,255,255,0.5)",
            pointerEvents: "none" }} />
          {Array.from({ length: n - 2 }, (_, k) => (
            <div key={k} style={{ position: "absolute",
              left: `calc(${PAD}px + ${((k + 1) / (n - 1)).toFixed(4)} * (100% - ${PAD * 2}px))`,
              top: "50%", transform: "translate(-50%, -50%)",
              width: 1.5, height: 14, background: "rgba(255,255,255,0.4)",
              pointerEvents: "none" }} />
          ))}
          <div style={{ position: "absolute", left: handleLeftPct, top: "50%",
            transform: "translate(-50%, -50%)", width: 28, height: 28,
            borderRadius: "50%", background: "#262626",
            border: "1.5px solid #fc8207",
            boxShadow: "0 0 10px rgba(252,130,7,0.4), 0 2px 6px rgba(0,0,0,0.5)",
            zIndex: 3, pointerEvents: "none" }} />
        </div>
        <div style={{ textAlign: "center", color: "#dddddd", fontSize: isPortrait ? 11 : 13,
          letterSpacing: "0.4px", marginTop: isPortrait ? 0 : 8,
          lineHeight: isPortrait ? "11px" : "normal", minHeight: isPortrait ? 11 : 18 }}>
          {eras[seg]}
        </div>
      </div>
    </div>
  );
}

export default function HandelswegeTimebar2D() {
  const snapEnglisch = useSnapshot(stateEnglisch);
  return <Timebar eras={snapEnglisch.isEnglisch ? ERAS_EN : ERAS_DE} />;
}
